import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface Categories {
  id: number;
  label: string;
  path: string;
}

interface Stations {
  id: number;
  label: string;
}

@Component({
  selector: 'app-personal-settings',
  templateUrl: './personalSettings.component.html',
  styleUrls: ['./personalSettings.component.scss']
})
export class PersonalSettingsComponent {

  stationsSelected: number[] = [];
  categorieSelected: number | null = null;
  preferNickname = false;

  stations: Stations[] = [];
  categories: Categories[] = [];
  hasNickname = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private dataIn: any
  ) {
    this.stations = dataIn.stations || [];
    this.categories = dataIn.categories || [];
    this.hasNickname = !!dataIn.hasNickname;
    this.preferNickname = !!dataIn.currentPreferNickname;

    if (dataIn.currentStations) {
      this.stationsSelected = dataIn.currentStations.split(',').map(x => Number(x)).filter(x => !isNaN(x));
    }
    if (dataIn.currentCategorie) {
      this.categorieSelected = Number(dataIn.currentCategorie);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    const stations = this.stationsSelected && this.stationsSelected.length > 0
      ? this.stationsSelected.join(',')
      : null;
    const categorie = this.categorieSelected !== null && this.categorieSelected !== undefined
      ? this.categorieSelected.toString()
      : null;

    this.dialogRef.close({ action: 'save', data: { stations, categorie, preferNickname: this.preferNickname } });
  }

  reset() {
    this.dialogRef.close({ action: 'reset' });
  }
}
